module.exports = __webpack_public_path__ + "static/portfolio-img5-964f63b583f365532685c2f624c17ccd.jpg";